module.exports = __webpack_public_path__ + "media/images/flags/16/Moldova-9c1877c4d409f7f4c0f5cf749ca9f1bb.png";